import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "../../i18n";
import { Lang, SUPPORTED_LANGS } from "../../i18n/lang";

/**
 * Switches the UI language. Kept small on purpose: it sits in the sidebar
 * next to the navigation and in the header of the sign-in and registration
 * screens, which have no sidebar.
 */
export const LanguageSwitcher = () => {
  const { lang, setLang, t } = useTranslation();

  const handleChange = (_: unknown, value: Lang | null) => {
    if (value) setLang(value);
  };

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={lang}
      onChange={handleChange}
      aria-label={t("language.label")}
    >
      {SUPPORTED_LANGS.map((code) => (
        <ToggleButton
          key={code}
          value={code}
          lang={code}
          aria-label={t(`language.${code}`)}
        >
          {code.toUpperCase()}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
